import React from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import SouthRoundedIcon from "@mui/icons-material/SouthRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import AppButton from "../../components/common/AppButton";
import "./SellerPlanChangeModal.scss";

const COPY = {
  deadline: {
    title: "You're on the free plan now",
    body:
      "The Premium price change wasn't accepted in time, so your account switched to Free. This affects new orders going forward. Nothing already in production changes.",
    primary: "Upgrade to Premium",
    secondary: "Continue on Free",
    rows: [
      ["Order pricing", "Back to free-plan rates"],
      ["Premium features", "Turned off"],
    ],
  },
  switch: {
    title: "Switching to the Free plan?",
    body:
      "Premium features and discounted pricing will turn off for new orders. Nothing already in production changes.",
    primary: "Keep Premium",
    secondary: "Switch to Free",
    rows: [
      ["Order pricing", "Back to free-plan rates"],
      ["Premium features", "Turned off"],
    ],
  },
};

/**
 * Shared Free-plan modal. `variant="deadline"` is after a missed price
 * change. `variant="switch"` confirms a seller leaving Premium.
 */
export default function SellerPlanChangeModal({
  open,
  variant = "deadline",
  busy = false,
  onPrimary,
  onSecondary,
  onClose,
}) {
  const copy = COPY[variant] || COPY.deadline;
  const close = onClose || onSecondary;

  return (
    <Dialog
      open={!!open}
      onClose={busy ? undefined : close}
      maxWidth="sm"
      fullWidth
      className="ssp-plan-change-dialog"
      PaperProps={{ className: "ssp-plan-change-paper" }}
    >
      <div className="ssp-plan-change">
        <div className="ssp-plan-change-top">
          <span className="ssp-plan-change-icon" aria-hidden>
            <SouthRoundedIcon />
          </span>
          <IconButton
            className="ssp-plan-change-x"
            onClick={close}
            disabled={busy}
            aria-label="Close"
            size="small"
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </div>
        <h2>{copy.title}</h2>
        <p>{copy.body}</p>
        <dl className="ssp-plan-change-rows">
          {copy.rows.map(([label, value]) => (
            <div key={label} className="ssp-plan-change-row">
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        <div className="ssp-plan-change-actions">
          <AppButton
            className="ssp-plan-change-primary"
            onClick={onPrimary}
            disabled={busy}
          >
            {copy.primary}
          </AppButton>
          <AppButton
            className="ssp-plan-change-secondary"
            color="#fff"
            textColor="#1a1a1a"
            borderColor="#d5d1c8"
            onClick={onSecondary}
            disabled={busy}
          >
            {copy.secondary}
          </AppButton>
        </div>
      </div>
    </Dialog>
  );
}
